// 종목 관련 API 함수 (tb_stock_master)
import axiosInstance from './axiosInstance';

// 종목 목록 조회 (필터 조건 선택)
export const fetchStocks = async (params = {}) => {
  const response = await axiosInstance.get('/stocks', { params });
  return response.data.data;
};

// 종목 등록 (관리자는 targetUserId로 다른 사용자 종목 등록 가능)
export const createStock = async (payload, targetUserId = null) => {
  const params = targetUserId ? { target_user_id: targetUserId } : {};
  const response = await axiosInstance.post('/stocks', payload, { params });
  return response.data;
};

// 종목 수정
export const updateStock = async (id, payload) => {
  const response = await axiosInstance.put(`/stocks/${id}`, payload);
  return response.data;
};

// 종목 삭제
export const deleteStock = async (id) => {
  const response = await axiosInstance.delete(`/stocks/${id}`);
  return response.data;
};
